import styled from '@app/styled';
import { color, spacing, typography } from '@app/theme';

export const Trigger = styled.button`
    all: initial;
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
`;

export const List = styled.ul`
    margin: 0;
    padding: ${spacing(4)};
    display: grid;
    gap: ${spacing(1)};
    list-style: none;
`;

export const Item = styled.li`
    ${typography('custom.description')}
    color: ${color('text.light.default')};
`;
